import React, { useEffect, useState } from "react";
import "./AssetManagementDashboard.css";
import { callAPI } from "../../../../axios";
import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";

function formatMb(mb, decimals = 1) {
  if (
    mb === 0 ||
    mb === undefined ||
    typeof mb !== "number" ||
    Number.isNaN(mb)
  ) {
    return "0 MB";
  }

  const sizes = ["MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const k = 1000;

  let i = 0;
  let value = mb;

  // promote MB → GB → TB ... every 1000
  while (value >= k && i < sizes.length - 1) {
    value = value / k;
    i++;
  }

  const rounded = parseFloat(value.toFixed(decimals));
  return `${rounded} ${sizes[i]}`;
}

export default function AssetManagementDashboard() {
  const [loader, setLoader] = useState(false);
  const [hotelStorageDetailsById, setHotelStorageDetailsById] = useState([]);
  const [hotelStorageDetailsList, setHotelStorageDetailsList] = useState([]);

  const [selectedHotel, setSelectedHotel] = useState("");
  const [selectedHotelUsage, setSelectedHotelUsage] = useState(0);

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("");
  const [inputPageValue, setInputPageValue] = useState(1);

  useEffect(() => {
    hotelStorageDetailsListApi();
  }, [selectedPage]);

  useEffect(() => {
    if (hotelStorageDetailsList?.data?.length>0) {
      onHotelCHnageHandler(hotelStorageDetailsList?.data[0]?.hotelName)
    }
  }, [hotelStorageDetailsList]);

  const onHotelCHnageHandler = (hotel) => {
    hotelStorageDetailsByIdApi("hotelName", hotel);
    setSelectedHotel(hotel)
  };

  const hotelStorageDetailsByIdApi = (FilterName, filterValue) => {
    const apiPath = `/search-asset-details`;
    setLoader(true);
    callAPI(apiPath, "POST", { [FilterName]: filterValue })
      .then((response) => {
        setHotelStorageDetailsById(response?.assetManagementResponse);
        const tempUsage = response?.assetManagementResponse?.reduce(
          (acc, curr) => acc + curr?.totalSizeMb,
          0
        );
        setSelectedHotelUsage(tempUsage);
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setLoader(false);
      });
  };

  const hotelStorageDetailsListApi = () => {
    const apiPath = `/storage/summary?pageNo=${selectedPage}&recordsPerPage=10`;
    setLoader(true);
    callAPI(apiPath, "GET")
      .then((response) => {
        setHotelStorageDetailsList(response);
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1);
        setPaginationError("");
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setLoader(false);
      });
  };

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value);
    setPaginationError("");
    setSelectedPage(value);
  };

  const totalUsed = 30; // GB

  return (
    <>
      <p className="mb-1 ms-1">
        <b>Asset Management Dahsboard (Only for HMS Hotels)</b>
      </p>
      <div className="row config-hotel">
        <div className="col-12 left-column">
          {loader && (
            <div className="circular-progress">
              <CircularProgress />
            </div>
          )}
          <div className="asset-root">
            <div className="asset-grid">
              {/* Left card: Storage Usage */}
              <div className="card-hotel border">
                <h2 className="card-heading">Storage Usage</h2>

                <div className="row-space">
                  <span className="label-strong">Total</span>
                  <span className="label-strong">
                    {(hotelStorageDetailsList?.totalSize / 1024).toFixed(3)} GB
                  </span>
                </div>
                <ProgressBar
                  value={(hotelStorageDetailsList?.totalSize / 1024).toFixed(3)}
                  max={10}
                />

                {hotelStorageDetailsList?.data?.map((h) => (
                  <div key={h.hotelName} className="hotel-row">
                    <div
                      onClick={() => onHotelCHnageHandler(h.hotelName)}
                      className="row-space cursor-pointer"
                    >
                      <span className="label-normal">{h.hotelName}</span>
                      <span className="label-normal">
                        {formatMb(h.totalSizeMb, 2)}
                      </span>
                    </div>
                    <ProgressBar
                      value={h.totalSizeMb?.toFixed(3)}
                      max={1000}
                    />
                  </div>
                ))}
                <Custom_Paingation
                  selectedPage={selectedPage}
                  totalPageCount={totalPageCount}
                  paginationError={paginationError}
                  inputPageValue={inputPageValue}
                  setSelectedPage={setSelectedPage}
                  setPaginationError={setPaginationError}
                  setInputPageValue={setInputPageValue}
                  onPageChange={onPageChange}
                />
              </div>

              {/* Right card: Hotel wise Storage */}
              <div className="card-details border">
                <h2 className="card-heading">Hotel Wise Storage Usage</h2>

                <div className="row-space top-row">
                  <span className="label-strong">{selectedHotel}</span>
                  <span className="label-strong">
                    {(selectedHotelUsage / 1024).toFixed(3)} GB
                  </span>
                </div>
                <ProgressBar value={(selectedHotelUsage / 1024).toFixed(3)} max={1} />

                <div className="breakdown-list">
                  {hotelStorageDetailsById?.map((item) => (
                    <div
                      key={item.configName}
                      className="row-space breakdown-row"
                    >
                      <span className="label-normal">{item.configName}</span>
                      <span className="label-normal">
                        {formatMb(item?.totalSizeMb, 2)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function ProgressBar({ value, max }) {
  const pct = Math.min(100, (value / max) * 100);
  return (
    <div className="progress-track">
      <div className="progress-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
